import { Disciplines } from "enums/disciplines";
import { FixtureStatuses } from "enums/fixtureStatuses";
import { Roles } from "enums/roles";
import { RosterPositions } from "enums/rosterPositions";
import { Standards } from "enums/standards";
import { UniformItemBottomTypes } from "enums/uniformItemBottomTypes";
import { UniformItemColors } from "enums/uniformItemColors";
import { UniformItemTopTypes } from "enums/uniformItemTopTypes";
import { UniformItemTypes } from "enums/uniformItemTypes";
import type { SportConfiguration } from "types/sportConfiguration";
import { defaultsConfig } from "./defaults";

const rosterPositions: Array<RosterPositions> = [
  RosterPositions.AttackingMidfield,
  RosterPositions.CentreForward,
  RosterPositions.CentreHalf,
  RosterPositions.Defender,
  RosterPositions.DefensiveMidfield,
  RosterPositions.Forward,
  RosterPositions.FullBack,
  RosterPositions.GoalKeeper,
  RosterPositions.HalfBack,
  RosterPositions.LeftForward,
  RosterPositions.Midfielder,
  RosterPositions.Outfielder,
  RosterPositions.RightForward,
  RosterPositions.Striker,
  RosterPositions.Sweeper,
];

const fixtureStaffRoles: Array<Roles> = [Roles.Manager, Roles.Doctor, Roles.Coach, Roles.Physiotherapist, Roles.Other];

const seasonStaffRoles: Array<Roles> = [
  Roles.CoachAssistant,
  Roles.Coach,
  Roles.Doctor,
  Roles.Manager,
  Roles.Other,
  Roles.PhysicalTrainer,
  Roles.Physiotherapist,
  Roles.Psychologist,
  Roles.StandInManager,
  Roles.TeamLeader,
  Roles.TeamMediaOfficer,
  Roles.Translator,
  Roles.VideoAnalyst,
];

const uniforms: SportConfiguration["uniforms"] = {
  bottomOptions: [UniformItemBottomTypes.Shorts, UniformItemBottomTypes.Skirts],
  items: [
    {
      titleIntlKey: "uniformModal.preview.player",
      topType: [UniformItemTopTypes.ShortSleeve],
      itemTypes: {
        [UniformItemTypes.Top]: [UniformItemColors.Primary, UniformItemColors.Secondary],
        [UniformItemTypes.Bottom]: [UniformItemColors.Primary],
        [UniformItemTypes.Socks]: [UniformItemColors.Primary],
      },
    },
    {
      titleIntlKey: "uniformModal.preview.goalkeeper",
      topType: [UniformItemTopTypes.LongSleeve],
      itemTypes: {
        [UniformItemTypes.GoalkeeperTop]: [UniformItemColors.Primary, UniformItemColors.Secondary],
        [UniformItemTypes.GoalkeeperBottom]: [UniformItemColors.Primary],
        [UniformItemTypes.Socks]: [UniformItemColors.Primary],
      },
    },
  ],
};

export const hockeyConfig: SportConfiguration = {
  ...defaultsConfig,
  fixtureStatuses: [...defaultsConfig.fixtureStatuses, FixtureStatuses.WarmUp],
  rosterPositions,
  fixtureStaffRoles,
  seasonStaffRoles,
  entityStandards: [...defaultsConfig.entityStandards, Standards.WorldLeague, Standards.HockeySeriesOpen],
  entityDisciplines: [Disciplines.Indoor, Disciplines.Outdoor, Disciplines.Hockey5S, Disciplines.Parahockey],
  uniforms,
};
